import React from "react";
import { Helmet } from "react-helmet";
import {projectName} from "../../../resources/constants";

export default function PageName(props) {
    const page =
        typeof props.page !== "undefined"
            ? props.page !== ""
                ? " | " + props.page
                : ""
            : "";
    return (
        <Helmet>
            <title>{`${projectName} ${page}`}</title>
        </Helmet>
    );
}
